import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const StarHalfIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="m11.406 9.326 2.471-2.52-3.424-.525-.634-.1-.289-.606L8.001 2.33v9.709l.567.312 3.059 1.694-.577-3.579-.116-.665zm4.346-2.642-3.49 3.57.827 5.04c.067.444-.087.706-.385.706a.8.8 0 0 1-.385-.121l-4.318-2.38-4.318 2.38a.8.8 0 0 1-.385.121c-.298 0-.452-.262-.384-.706l.827-5.04L.24 6.683c-.414-.433-.279-.857.298-.947L5.366 5 7.53.413C7.655.141 7.828 0 8 0s.337.141.471.413l2.164 4.588 4.828.736c.577.09.712.514.288.947"
      clipRule="evenodd"
    />
  </svg>
);
StarHalfIcon.id = 'StarHalfIcon';
StarHalfIcon.displayName = 'StarHalfIcon';
export default StarHalfIcon;
